import { ReportsSchoolSearchEffects } from './reports-school-search.effect';
import { ReportsSchoolSearchResultsEffects } from './reports-school-searchresults.effect';
import { ReportsPrefsSearchResultsEffects } from './reports-prefs.effects';

export const effects: any[] = [ReportsSchoolSearchEffects, ReportsSchoolSearchResultsEffects, ReportsPrefsSearchResultsEffects];

export * from './reports-school-search.effect';
export * from './reports-school-searchresults.effect';
export * from './reports-prefs.effects';
